import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { LearningSummaryTitle } from "../../../../Constants/Constants";
import ReactApexChart from "react-apexcharts";
import { OptionsLearning } from "../../../../Data/General/Dashboard/Default";

const LearningSummary = () => {
  return (
    <Col xl="6" className="box-col-6">
      <Card>
        <DashboardCommonHeader title={LearningSummaryTitle} dropdownClass="dropdown-toggle" text="(80% activity growth)"/>
        <CardBody className="pb-0">
          <div id="learning-chart">
            <ReactApexChart options={OptionsLearning} series={OptionsLearning.series} type="line" height={320} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default LearningSummary;
